import { TargetLanguage } from '../types'
import Modal from '../util/modal'
import LangList from './lang-list'

export const languageModalId = 'languageModal'

function LangSelector({ targetLanguages }: { targetLanguages: TargetLanguage[] }) {
    return (
        <Modal id={languageModalId} title="Choose your favorite languages">
            <div className="flex h-[60vh] flex-wrap justify-center gap-2 overflow-auto md:h-auto">
                <LangList targetLanguages={targetLanguages} />
            </div>
        </Modal>
    )
}
export default LangSelector
